export const PINNED_ID = -1001;
export const PROMOTIONS_ID = -1002;
export const ALL_ID = -1000;
export const SPORTS_HOME_ID = -5000;
